import React from 'react';

// Material UI Components
import {Tooltip, Button} from '@material-ui/core';

// Icons
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';

export default function Alignment( {StyleButton, contentBlock, onClickToggleBlockStyle} ) {
    const alignmentTypes = ["ALIGNLEFT", "ALIGNCENTERED", "ALIGNRIGHT"];

    let [leftActive] = React.useState(false);
    let [centeredActive] = React.useState(false);
    let [rightActive] = React.useState(false);
    
    // Will loop through the alignmentTypes array and will check whether the cursor is on the style
    alignmentTypes.forEach(item => {
        const alignmentType = contentBlock.type === item ? contentBlock : {};

        if(alignmentType.type === "ALIGNLEFT"){
            leftActive = true;
            centeredActive = false;
            rightActive = false;
        } 
        if(alignmentType.type === "ALIGNCENTERED"){
            leftActive = false;
            centeredActive = true;
            rightActive = false;
        }
        if(alignmentType.type === "ALIGNRIGHT"){
            leftActive = false;
            centeredActive = false;
            rightActive = true;
        }
    });

    return (
        <React.Fragment>
            {
                alignmentTypes.map((item, index) => {
                    let currentFormat;
                    const itemText = (item === "ALIGNLEFT") ? "ALIGN LEFT" : (item === "ALIGNCENTERED") ? "ALIGN CENTER" : "ALIGN RIGHT" ;
                    
                    if(item === "ALIGNLEFT"){
                        currentFormat = leftActive
                    }
                    if(item === "ALIGNCENTERED"){
                        currentFormat = centeredActive
                    }
                    if(item === "ALIGNRIGHT"){
                        currentFormat = rightActive
                    }
                    
                    return(
                        <div key={index} onMouseDown={(event) => {
                            event.preventDefault();
                            if(currentFormat === true){
                                return
                            }else{
                                onClickToggleBlockStyle(item)
                            }
                        }}>
                            <Tooltip title={itemText} placement="bottom">
                                <Button 
                                    aria-label={itemText} 
                                    className={StyleButton} 
                                    color={(currentFormat === true) ? "primary" : "inherit"} 
                                    size="large" 
                                    variant={(currentFormat === true) ? "contained" : "text"}>
                                    {
                                        item === "ALIGNLEFT" ? <FormatAlignLeftIcon />
                                            : item === "ALIGNCENTERED" ? <FormatAlignCenterIcon />
                                                : item === "ALIGNRIGHT" ? <FormatAlignRightIcon />
                                                    : ""
                                    }
                                </Button  >
                            </Tooltip>
                        </div>
                    );
                })
            }
        </React.Fragment>
    )
}
